<template>
    <div>

<!--body content start-->

<div id="main-page" class="page-content">

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 sm-mt-5">
        <ul id="imageGallery">
          <li data-thumb="images/product/01.jpg" data-src="images/product/01.jpg">
            <img class="img-fluid w-100" src="images/product/01.jpg" alt="" />
          </li>
          <li data-thumb="images/product/02.jpg" data-src="images/product/02.jpg">
            <img class="img-fluid w-100" src="images/product/02.jpg" alt="" />
          </li>
          <li data-thumb="images/product/03.jpg" data-src="images/product/03.jpg">
            <img class="img-fluid w-100" src="images/product/03.jpg" alt="" />
          </li>
          <li data-thumb="images/product/04.jpg" data-src="images/product/04.jpg">
            <img class="img-fluid w-100" src="images/product/04.jpg" alt="" />
          </li>
        </ul>
      </div>
       <div class="col-lg-6 col-md-6 mt-5 mt-lg-0">
        <div class="product-details">
          <h4>
        Women T-Shirt
        </h4>
          <div class="product-price my-4">$15.00 <span> $22.00</span>
            <span class="text-primary">
                      <i class="ti-star"></i>
                      <i class="ti-star"></i>
                      <i class="ti-star"></i>
                      <i class="ti-star"></i>
                      <i class="ti-star"></i>
                    </span>
          </div>
          <ul class="list-unstyled mb-4">
            <li class="mb-2"><span class="text-black"> Availibility: </span> In Stock</li>
            <li><span class="text-black"> Categories :</span> Women's</li>
          </ul>
          <p class="mb-4">Nulla eget sem vitae eros pharetra viverra Nam vitae luctus ligula suscipit risus nec eleifend Pellentesque eu quam sem, ac malesuada leo sem quam pellente Awesome sliders opportunity</p>

          <div class="filter-color">
          <ul class="list-inline">
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter1" name="ExampleRadios">
                <label class="form-check-label" for="color-filter1" data-bg-color="#3cb371"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter2" name="ExampleRadios" checked>
                <label class="form-check-label" for="color-filter2" data-bg-color="#4876ff"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter3" name="ExampleRadios">
                <label class="form-check-label" for="color-filter3" data-bg-color="#0a1b2b"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter4" name="ExampleRadios">
                <label class="form-check-label" for="color-filter4" data-bg-color="#f94f15"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter5" name="ExampleRadios">
                <label class="form-check-label" for="color-filter5" data-bg-color="#e70fe4"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter6" name="ExampleRadios">
                <label class="form-check-label" for="color-filter6" data-bg-color="#ffc300"></label>
              </div>
            </li>
          </ul>
        </div>
          <div class="my-4">
            <span class="mb-3 text-black d-block">Select Size</span>
          <div class="size-choose">
            <ul class="list-inline">
              <li>
                <input name="sc" id="s-size" type="radio">
                <label for="s-size">S</label>
              </li>
              <li>
                <input name="sc" id="m-size" checked="" type="radio">
                <label for="m-size">M</label>
              </li>
              <li>
                <input name="sc" id="l-size" type="radio">
                <label for="l-size">L</label>
              </li>
              <li>
                <input name="sc" id="xl-size" type="radio">
                <label for="xl-size">XL</label>
              </li>
              <li>
                <input name="sc" id="xxl-size" type="radio">
                <label for="xxl-size">XXL</label>
              </li>
            </ul>
          </div>
          </div>
          <div>
            <span class="mb-3 text-black d-block">Quantity</span>
            <button class="btn-product btn-product-up"> <i class="fas fa-minus"></i>
            </button>
            <input class="form-product" type="number" name="form-product" value="1">
            <button class="btn-product btn-product-down"> <i class="fas fa-plus"></i>
            </button>
          </div>
          <div class="d-sm-flex align-items-center mt-5">
            <button class="btn btn-theme"><span>Add To Cart <i class="fas fa-shopping-bag mr-1"></i></span>
            </button>
             <button class="btn btn-theme"><span>Add To WishList <i class="far fa-heart mr-1"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--tab start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="tab">
          <!-- Nav tabs -->
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist"> <a class="nav-item nav-link active" id="nav-tab1" data-toggle="tab" href="#tab3-1" role="tab" aria-selected="true">Description</a>
              <a class="nav-item nav-link" id="nav-tab2" data-toggle="tab" href="#tab3-2" role="tab" aria-selected="false">Additional information</a>
              <a class="nav-item nav-link" id="nav-tab3" data-toggle="tab" href="#tab3-3" role="tab" aria-selected="false">Reviews (2)</a>
            </div>
          </nav>
          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade show active" id="tab3-1">
              <h5 class="mb-3">Product Description</h5>
              <p class="lead mb-0">ornare mi vel risus porttitor dignissim. Nunc eget risus at ipsum blandit ornare vel sed velit. Proin gravida arcu nisl, a dignissim mauris placerat Praesent pharetra, justo ut scelerisque mattis, leo quam aliquet diam, congue laoreet elit metus eget diam. Proin ac metus diam. In quis scelerisque velit. Proin pellentesque neque ut scelerisque dapibus. Praesent elementum feugiat dignissim. Nunc placerat mi id nisi interdum mollis. Praesent pharetra, justo ut scelerisque mattis, leo quam aliquet diam, nisi interdum mollis. Praesent pharetra, justo ut scelerisque mattis, leo quam aliquet diam.</p>
            </div>
            <div role="tabpanel" class="tab-pane fade" id="tab3-2">
              <h5 class="mb-3">Additional information</h5>
              <table class="table table-bordered mb-0">
                <tbody>
                  <tr>
                    <td>Size</td>
                    <td>Small, Medium, Large &amp; Extra Large</td>
                  </tr>
                  <tr>
                    <td>Color</td>
                    <td>Read, Blue, Green &amp; Black</td>
                  </tr>
                  <tr>
                    <td>Chest</td>
                    <td>38 inches</td>
                  </tr>
                  <tr>
                    <td>Waist</td>
                    <td>20 cm</td>
                  </tr>
                  <tr>
                    <td>Length</td>
                    <td>35 cm</td>
                  </tr>
                  <tr>
                    <td>Fabric</td>
                    <td>Cotton, Silk &amp; Synthetic</td>
                  </tr>
                  <tr>
                    <td>Warranty</td>
                    <td>6 Months</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div role="tabpanel" class="tab-pane fade" id="tab3-3">
              <div class="row">
                <div class="col-md-7">
                  <div class="row total-rating">
                    <div class="col-md-6">
                      <div class="box-total">
                        <h5>Overall</h5>
                        <h4>4.0</h4>
                        <h6>(03 Reviews)</h6>
                      </div>
                    </div>
                    <div class="col-md-6 mt-5 mt-md-0">
                      <div class="rating-list">
                        <h5>Based on 3 Reviews</h5>
                        <ul class="list-unstyled">
                          <li> <a href="#">5 Star
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i> 01</a>
                          </li>
                          <li> <a href="#">4 Star
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                               <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i> 01</a>
                          </li>
                          <li> <a href="#">3 Star
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i> 01</a>
                          </li>
                          <li> <a href="#">2 Star
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i> 01</a>
                          </li>
                          <li> <a href="#">1 Star
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i> 01</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="media-holder review-list mt-5">
                    <div class="media">
                      <img class="img-fluid ml-3" alt="image" src="images/thumbnail/01.jpg">
                      <div class="media-body">
                        <h6>Charlote Kerry</h6>
                        <p>It's ironic that when the then-understood Latin was scrambled, it became as incomprehensible as Greek; the phrase 'it's Greek to me' and 'greeking' have common semantic roots!</p> <span class="review-rating">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                    </span>
                      </div>
                    </div>
                    <div class="media mt-5">
                      <img class="img-fluid ml-3" alt="image" src="images/thumbnail/02.jpg">
                      <div class="media-body">
                        <h6>Jesson Mart</h6>
                        <p>May a cusstums offficer somewon nothing of a poison-filled. Until, from a twho, twho chaffinch may also pursue it, not even a lump. But as twho, as a tank</p> <span class="review-rating">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                    </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="post-comments mt-5 pos-r">
                    <div class="section-title mb-3">
                      <h5>Add REVIEW</h5>
                    </div>
                    <form id="contact-form" method="post" action="http://themeht.com/agencio/rtl/contact.php">
                      <div class="messages"></div>
                      <div class="form-group">
                        <input id="form_name" type="text" name="name" class="form-control" placeholder="Name" required="required" data-error="Name is required.">
                        <div class="help-block with-errors"></div>
                      </div>
                      <div class="form-group">
                        <input id="form_email" type="email" name="email" class="form-control" placeholder="Email Address" required="required" data-error="Valid email is required.">
                        <div class="help-block with-errors"></div>
                      </div>
                      <div class="form-group clearfix">
                        <select class="form-control">
                          <option value="">Rating -- Select</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <input id="form_number" type="text" name="name" class="form-control" placeholder="Phone Number" required="required">
                      </div>
                      <div class="form-group">
                        <textarea id="form_message" name="message" class="form-control" placeholder="Type Comment" rows="4" required="required" data-error="Please,leave us a message."></textarea>
                        <div class="help-block with-errors"></div>
                      </div>
                      <button class="btn btn-theme mt-3">Post Comment</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--tab end-->

</div>

<!--body content end--> 
    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'Product Checkout'
        }
    },
};
</script>
